import OptionalDateTimePicker from "components/DatePicker/OptionalDateTimePicker";
import moment from "moment";
import React from "react";
import { FreefieldInPageEditInputProps } from "shared/utils/freeFields/models";
import { isFreeFieldDateEmpty } from "shared/utils/freeFields/utils";

const FFInPageEditOptionalDateTimePicker = (props: FreefieldInPageEditInputProps) => {
  const [date, setDate] = React.useState(!isFreeFieldDateEmpty(props.value) ? moment.utc(props.value) : undefined);

  const onDateChange = (date: moment.Moment) => {
    setDate(date);
    props.onChange(date ? date.toISOString() : undefined);
  };

  return <OptionalDateTimePicker
    focusOnMount
    validatorKey={`freefield${props.reference}`}
    minDate={moment(serverReference.constants.appointment.minDate)}
    maxDate={moment(serverReference.constants.appointment.maxDate)}
    value={date}
    onChange={onDateChange}
    onEnter={() => props.submit()}
    onEsc={() => props.cancel()}
  />
};

export default FFInPageEditOptionalDateTimePicker;